import React, { useMemo } from "react";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { View } from "@common/types/views/views";
import {
    SendingDomainColumn,
    SendingDomainRow,
    SendingDomainsTableMeta,
    sendingDomainsViewConfig,
} from "./sendingDomainsViewConfig";

const defaultView: View = {
    columns: [
        { id: SendingDomainColumn.DOMAIN },
        { id: SendingDomainColumn.METHOD },
        { id: SendingDomainColumn.STATUS },
        { id: SendingDomainColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
    },
};

interface SendingDomainsViewProps {
    data: SendingDomainRow[] | null;
    onConnectDomain: (domain: string) => void;
}

export const SendingDomainsView: React.FC<SendingDomainsViewProps> = ({
    data,
    onConnectDomain,
}) => {
    const tableMeta = useMemo<SendingDomainsTableMeta>(
        () => ({ callbacks: { onConnectDomain } }),
        [onConnectDomain],
    );

    return (
        <ViewTable
            data={data}
            view={defaultView}
            config={sendingDomainsViewConfig}
            tableMeta={tableMeta}
            emptyView={() => (
                <EmptyState
                    header="No sending domains yet"
                    body="Add a domain and verify it with DNS records or your own SMTP server."
                />
            )}
            enableColumnResizing={false}
            outerBorder
        />
    );
};
